/** Format a unix timestamp as a relative time string */
export const formatLastMessage = (ts) => {
  if (!ts) return "";
  const now = Math.floor(Date.now() / 1000);
  const diff = now - ts;
  if (diff < 60) return "now";
  if (diff < 3600) return `${Math.floor(diff / 60)}m`;
  if (diff < 86400) return `${Math.floor(diff / 3600)}h`;
  return `${Math.floor(diff / 86400)}d`;
};

/** Standard row classes for active/inactive sidebar items */
export const chatRowClasses = (isActive) =>
  [
    "w-full text-left rounded-md px-2 py-1.5 text-[12px] truncate transition-colors flex items-center gap-x-1.5",
    isActive
      ? "text-[#0EA5E9] bg-[#0EA5E9]/[0.08] font-medium"
      : "text-zinc-500 dark:text-zinc-500 hover:text-zinc-700 dark:hover:text-zinc-300 hover:bg-zinc-50 dark:hover:bg-zinc-800/40",
  ].join(" ");
